// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2A10q","header":"PatientBlock_header__1BWxw","label":"PatientBlock_label__3kkv5","option":"PatientBlock_option__Z-JVW"};